import { Box, Drawer, IconButton, Typography, Link as MUILink } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import { useGetAvailableIntegrations } from 'apis/agency/integrations/hook';
import IntegrationsDrawerSkeleton from './IntegrationsDrawerSkeleton';
import ReactMarkdown from 'react-markdown';
import Grid from '@mui/material/Grid2';
interface IntegrationsDrawerProps {
  open: boolean;
  onClose: () => void;
}

export default function IntegrationsDrawer({ open, onClose }: IntegrationsDrawerProps) {
  const { data: availableIntegrations, isLoading } = useGetAvailableIntegrations({ per_page: 999 });

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: '100%', md: '900px' }, p: 3 }
      }}
    >
      {/* Header */}
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={3}>
        <Typography variant='h6' fontWeight={600}>
          Integrations
        </Typography>
        <IconButton onClick={onClose}>
          <IoMdClose />
        </IconButton>
      </Box>
      {isLoading ? (
        <IntegrationsDrawerSkeleton open={open} onClose={onClose} />
      ) : (
        <Grid container spacing={3}>
          {availableIntegrations?.data?.map((item: any) => (
            <Grid key={item?.id} size={{ xs: 12, md: 6 }}>
              <Box
                bgcolor='white'
                p={2}
                border='1px solid #ECECEC'
                borderRadius={2}
                display='flex'
                flexDirection='column'
                justifyContent='space-between'
                height='100%'
              >
                {/* Top Section */}
                <Box>
                  <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <img src={item.avatar_url} alt={item.name} style={{ maxHeight: 30 }} />
                    <Typography
                      sx={{
                        color: '#077f13',
                        bgcolor: '#dbfcde',
                        px: 2,
                        fontSize: 14,
                        borderRadius: '15px',
                        fontWeight: 500
                      }}
                    >
                      {item.wholesale_price === '0.0' ? (
                        <b>Free</b>
                      ) : (
                        <>
                          <b>${item.wholesale_price}</b>
                          <Box component='span' fontSize={10}>
                            /Connection/Month
                          </Box>
                        </>
                      )}
                    </Typography>
                  </Box>

                  <Typography my={1} color='secondary' fontSize={14}>
                    <ReactMarkdown
                      components={{
                        a: ({ ...props }) => (
                          <MUILink
                            {...(props as any)}
                            component='a'
                            target='_blank'
                            rel='noopener'
                            sx={{ color: 'primary.main', fontWeight: 500 }}
                          />
                        ),
                        p: ({ ...props }) => <span {...props} />
                      }}
                    >
                      {item?.description}
                    </ReactMarkdown>
                  </Typography>
                </Box>

                {/* Bottom Section */}
                <Box mt={2}>
                  <Typography fontSize={12} color='secondary'>
                    Reseller Price
                  </Typography>
                  <Typography fontWeight='500' fontSize={18} color='#077f13'>
                    ${item.reseller_price}
                  </Typography>
                  <Typography fontWeight='500' color='#077f13' fontSize={12}>
                    /Connection/Month
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Drawer>
  );
}
